/**
 * The selection names that are safe to show a user or hand to the model.
 *
 * AI-resolved companies carry their numeric rcid as `selection.name` until a
 * later API round patches in the real label (see `resolveUnknownCompanyNames`).
 * Anything reporting on selections before that patch — the trial allow-list, the
 * page's selection cap — can therefore be holding a bare id, which names nothing
 * a user recognises and which the model would repeat verbatim ("1435892 isn't
 * available on your trial"). Callers fall back to a generic message when this
 * comes back empty.
 */
export const nameableSelectionNames = (names: string[]): string[] =>
  names.filter((name) => !/^\d+$/.test(name.trim()));
